import { Box, Grid, Typography, styled, useTheme } from "@mui/material";

import ItemUser from "./Component/ItemUser";
import { useSelector } from "react-redux";
import { EmailIcon, People, PhoneTelephone } from "assets/Icon";

export function Users() {
  const theme = useTheme();
  const profile = useSelector((state) => state.user?.user?.data);

  return (
    <Grid item xs={12}>
      <BoxUser>
        <Typography variant="h4" textAlign="center">
          {profile?.name} {profile?.family}
        </Typography>

        <ItemUser
          icon={<People color={theme.palette.secondary.main} />}
          text={profile?.userName}
          profile={profile}
        />

        <ItemUser
          icon={<PhoneTelephone color={theme.palette.secondary.main} />}
          text={
            profile?.phoneNumberConfirmed ? profile?.phoneNumber : "تائید نشده"
          }
          profile={profile}
        />

        <ItemUser
          icon={<EmailIcon color={theme.palette.secondary.main} />}
          text={profile?.emailConfirmed ? profile?.email : "تائید نشده"}
          profile={profile}
        />
      </BoxUser>
    </Grid>
  );
}

const BoxUser = styled(Box)(({ theme }) => ({
  background: theme.palette.background.primaryGradient,
  borderRadius: "10px",
  border: `1px solid ${theme.palette.modules.border}`,
  padding: theme.spacing(2),
  marginTop: theme.spacing(4),
}));

export default Users;
